import { render, staticRenderFns } from "./RirekishoHobbyCard.vue?vue&type=template&id=9e40a472"
import script from "./RirekishoHobbyCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoHobbyCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports